import { ArrangementType as ArrangementApiType } from 'src/api/generated/touring/types';
import { ArrangementType } from '../../types';

export const mapArrangementType = (
  apiType: ArrangementApiType
): ArrangementType => {
  return {
    amount: apiType.amount ?? null,
    min: apiType.min ?? null,
    max: apiType.max ?? null,
  };
};
